module.exports = __webpack_public_path__ + "img/imagem2.296b66d2.png";